var render = function render(){var _vm=this,_c=_vm._self._c;return _c('index',_vm._b({ref:"index",attrs:{"hidePage":_vm.hidePage,"menuList":_vm.$store.state.menuList,"keyword":_vm.keyword,"subMenuList":_vm.subMenuList,"route":_vm.route,"icon":_vm.icon},on:{"onWidthChange":_vm.onWidthChange,"onsetCurrentMenu":_vm.onsetCurrentMenu}},'index',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }